<template>
  <div class="relative w-full max-w-full table-wrapper" :class="wrapperClass">
    <Transition name="fade" mode="out-in">
      <div class="-mx-5" :key="loading">
        <template v-if="loading">
          <slot name="loading">
            <div
              class="w-full min-h-[450px] pb-5 flex-y-center justify-center flex-col gap-3 px-5"
            >
              <div class="spinner"></div>
            </div>
          </slot>
        </template>
        <template v-else>
          <Table v-if="data?.length">
            <TableHeader>
              <TableRow>
                <TableHead
                  class="w-[100px] first:pl-5 last:!w-[80px]"
                  v-for="(h, index) in head"
                  :key="index"
                  :class="[
                    h.key === '_index'
                      ? 'first:!max-w-[50px] first:!min-w-[50px]'
                      : 'first:!min-w-[200px]',
                    thClass,
                  ]"
                >
                  {{ $t(h.title) }}
                </TableHead>
              </TableRow>
            </TableHeader>
            <TableBody v-if="data?.length">
              <TableRow
                :class="bodyTrClass"
                v-for="(d, index) in data"
                :key="index"
                @click="$emit('single', d)"
              >
                <TableCell
                  v-for="(h, idx) in head"
                  :key="idx"
                  class="first:pl-5"
                  :class="[tdClass]"
                >
                  <slot :name="h.key" :data="{ ...d, _index: getIndex(index) }">
                    {{ h.key === "_index" ? getIndex(index) : d[h.key] }}
                  </slot>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
          <slot v-else name="no-data">
            <div class="flex-center py-16">No Data</div>
          </slot>
        </template>
      </div>
    </Transition>
  </div>
</template>

<script setup lang="ts">
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { TClassName } from "@/types/common";
import { ITableHead } from "@/types/components/table";

interface Props {
  type?: "filled" | "transparent";

  head: ITableHead[];

  thClass?: TClassName;
  bodyTrClass?: TClassName;
  tdClass?: TClassName;
  wrapperClass?: TClassName;

  data: Record<string, any>[];

  limit: number;
  currentPage: number;
  loading?: boolean;
  statusKey?: string;
}
const props = withDefaults(defineProps<Props>(), {
  loading: true,
});

function getIndex(index: number) {
  return (props?.currentPage - 1) * props?.limit + index + 1;
}
</script>
<style>
.spinner {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background:
    radial-gradient(farthest-side, #16cc53 94%, #0000) top/6.4px 6.4px no-repeat,
    conic-gradient(#0000 30%, #16cc53);
  -webkit-mask: radial-gradient(
    farthest-side,
    #0000 calc(100% - 6.4px),
    #000 0
  );
  animation: spinner-c7wet2 1s infinite linear;
}

@keyframes spinner-c7wet2 {
  100% {
    transform: rotate(1turn);
  }
}
</style>
